export default __webpack_public_path__ + "static/media/Edge of Tartarus.6aa3c330.jpg";